module.exports = __webpack_public_path__ + "static/img/tst2-07-1.f818edb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-07-1.gif
// module id = 1+18
// module chunks = 1